<template>
  <ticket-submit-dialog :get-ticket-create-data="ticketData" :ticket-available="ticketAvailable" :closeDialog="cancelDialog">
    <div v-for="(item, i) in details" :key="i" class="mb-2">
      <div class="d-flex pb-2 " v-if="item.id">
        <div class="label">ID: </div>
        <div class="error-color ml-3">
          <div>{{ item.id }}</div>
        </div>
        <copy class="align-self-center ml-1" :message="item.id" />
      </div>
      <div class="d-flex pb-2">
        <div class="label">{{$t('common.text00090')}}: </div>
        <div class="error-color ml-3 overflow-auto">
          <div>{{ item.class }}</div>
          <div>{{ item.detail }}</div>
        </div>
      </div>
      <div class="d-flex pb-2 mt-2 border-bottom overflow-auto">
        <div class="label">{{$t('common.text00091')}}: </div>
        <pre class="error-color ml-3">{{ item.resource }} <copy :message="item.resource" /></pre>
      </div>
    </div>
    <div class="d-flex mt-3">
      <div class="label">{{$t('common.text00092')}}: </div>
      <div class="ml-3" style="width: calc(100% - 80px)">
        <pre>{{ request }} <copy :message="request" /></pre>
      </div>
    </div>
  </ticket-submit-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as R from 'ramda'
import TicketSubmitDialog from './TicketSubmit'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { changeToArr } from '@/utils/utils'

// 增强ErrorDialog,相比开源的ErrorDialog新增：
// * 增加开源反馈链接
// * 增加技术支持群组入口
// todo: 在用户提交工单前 如果检测到用户没有联系方式，引导用户填写联系方式
export default {
  name: 'ErrorDialog',
  components: { TicketSubmitDialog },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const details = changeToArr(this.params.error).map(val => ({
      ...val,
      resource: JSON.stringify(val.resource, null, 2),
    }))
    const request = JSON.stringify(this.params.request, null, 2)
    let errors = []
    const t = R.type(this.params.error)
    if (t === 'Array') {
      errors = this.params.error
    } else if (t === 'Object') {
      errors.push(this.params.error)
    }
    return {
      errors,
      details,
      request,
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    ticketAvailable () {
      // create request is not process-instances
      return this.errors.some((err) => {
        const login = this.$store.state.auth.canRenderDefaultLayout
        if (!login) return false
        const url = R.path(['resource', 'request', 'url'], err) || ''
        const code = R.path(['resource', 'code'], err) || 0
        return !(url.indexOf('/process-instances') >= 0 && code >= 500)
      })
    },
    priority () {
      const isCritical = this.errors.some((err) => { return err.resource && err.resource.code >= 500 })
      // response code >= 500
      return isCritical ? 'critical' : 'moderate'
    },
  },
  methods: {
    ticketData () {
      const comment = `所在页面: ${this.$route.fullPath}\n\n请求:\n ${this.request}\n\n响应:\n ${JSON.stringify(this.params.error, null, 2)}`
      return {
        variables: {
          process_definition_key: 'customer-service',
          priority: this.priority,
          initiator: this.userInfo.id,
          comment: comment,
        },
      }
    },
  },
}
</script>

<style lang="less" scoped>
.error-body {
  .label {
    width: 80px;
  }
}
</style>
